<template>
  <abstract-dialog-index v-if="!isSample">
    <component :is="getCurrentDialog" v-model="currentModal" :bindParams="options"></component>
  </abstract-dialog-index>
</template>

<script>
import AbstractDialogIndex from './index';
export default {
  name: 'AbstractDialog',
  components: {
    AbstractDialogIndex
  },
  props: {
    value: String,
    options: [Object, Array, String, Number, Function],
    sampleUnionId: Number
  },
  watch: {
    sampleUnionId () {
      if (!!this.currentModal) {
        this.isSample = true;
        this.$nextTick(() => {
          this.isSample = false;
          this.dealChange();
        })
      }
    },
    value () {
      this.currentModal = this.getType;
    },
    currentModal () {
      if (this.options.clearAll) {
        this.closeAll();
        this.$EventBus.$emit(`${this.$route.name}_refresh`, {});
        return null;
      }
      if (this.origin === 'prevBack') {
        this.origin = '';
      } else {
        this.dealChange();
      }
    }
  },
  computed: {
    getCurrentDialog () {
      const type = this.isSample ? this.options.sampleName : this.getType;
      if (!(!!type)) return null;
      const current = this.componentList[type] || {};
      return current.component || null;
    },
    async getOptions () {
      if (!(!!this.options)) return {};
      if (typeof this.options === 'string' || typeof this.options === 'number') return {options: this.options}
      if (typeof this.options === 'function') return await this.options();
      return this.options;
    },
    getType () {
      if (['lock', 'invalid', 'publicPool', 'blackList', 'hit'].indexOf(this.value) >= 0) {
        return 'operate';
      } else if (this.value === 'approve') {
        return this.getApproveName();
      }
      return this.value;
    }
  },
  data () {
    return {
      componentList: {
        'follow': {component: () => import('@/views/apply/applyFollow')},
        'customerFollow': {component: () => import('@/views/apply/applyCustomerFollow')},
        'customerFollowDetail': {component: () => import('@/views/apply/customerFollowDetail')}, // 跟进详情
        'report': {component: () => import('@/views/apply/applyReportBuilding')},
        'takeLook': {component: () => import('@/views/apply/applyTakeLook')},
        'concat': {component: () => import('@/views/apply/applyConcat')},
        'refund': {component: () => import('@/views/apply/applyReimburse')},
        'operate': {component: () => import('@/views/apply/applyOperate')},
        'confess': {component: () => import('@/views/apply/applyConfess')},
        'subscribe': {component: () => import('@/views/apply/applySubscribe')},
        'sign': {component: () => import('@/views/apply/applySign')},
        'settlement': {component: () => import('@/views/apply/applySettlement')},
        'merge': {component: () => import('@/views/apply/applymerge')},
        'orderDetail': {component: () => import('@/views/workFlow/order/detail')},
        'bussinessDetail': {component: () => import('@/views/workFlow/commercial/detail')},
        'yunVisitorDetail': {component: () => import('@/views/custome/yunVisitor/detail')},

        'customerDetail': {component: () => import('@/views/custome/customeDetail/index')},
        'customerDetailCopy': {component: () => import('@/views/custome/customeDetail/index')},
        'approveReport': {component: () => import('@/views/workFlow/approve/report/item')},
        'approveLook': {component: () => import('@/views/workFlow/approve/look/item')},
        'approveRecognition': {component: () => import('@/views/workFlow/approve/recognition/item')},
        'approveSubscribe': {component: () => import('@/views/workFlow/approve/subscribe/item')},
        'approveSign': {component: () => import('@/views/workFlow/approve/signing/item')},
        'approveSettlement': {component: () => import('@/views/workFlow/approve/settlement/item')},
        'approveRefund': {component: () => import('@/views/workFlow/approve/refund/item')},
        'approveLock': {component: () => import('@/views/workFlow/approve/lock/item')},
        'approveCollision': {component: () => import('@/views/workFlow/approve/collision/item')},
        'approveMerge': {component: () => import('@/views/workFlow/approve/merge/item')},
        'approveInvalid': {component: () => import('@/views/workFlow/approve/invalid/item')},
        'approveBlack': {component: () => import('@/views/workFlow/approve/black/item')},
        'approveHelper': {component: () => import('@/views/workFlow/approve/helper/item')},
        'taskGeneral': {component: () => import('@/views/task/component/taskGeneral')},
        'taskPerformance': {component: () => import('@/views/task/component/taskPerformance')},
        'clewDetail': {component: () => import('@/views/custome/enterpriceClew/clewDetail')},
        'clewApplyFollow': {component: () => import('@/views/custome/enterpriceClew/writeFollow')}, // 线索写跟进
        'dayLogBussinessMember': {component: () => import('@/views/statement/components/bussinessMember')}, // 日志报表客户业务明细详情
        'dayLogBussiness': {component: () => import('@/views/statement/components/bussinessTypes')}, // 日志报表业务详情
        'visitorDetail': {component: () => import('@/views/custome/visitor/detail')}, // 访客详情
        'customeHelper': {component: () => import('@/views/custome/customeDetail/helper/item')}, // 新增客户协助人
        'customeHelperRemove': {component: () => import('@/views/custome/customeDetail/helper/removeItem')}, // 移除客户协助人
        'UserCaculate': {component: () => import('@/views/statement/userAnalysisComp/detail')}, // 员工分析-详情弹出层
        'operateProject': {component: () => import('@/views/firm/project/item')}, // 新建/编辑项目
        'systemHousecardSet': {component: () => import('@/views/system/houseCardSetting/component/cardItem')}, // 系统管理-新房卡设置-查询设置
        'systemHousecardDetail': {component: () => import('@/views/system/houseCardSetting/component/cardDetail')}, // 系统管理-新房卡设置-查询设置-已获客详情
        'messageUserAnalysis': {component: () => import('@/views/workspace/message/useAnalysisDialog')}, //小云消息-使用分析详情
        'messageIncomplete': {component: () => import('@/views/workspace/message/incompleteDialog')}, //小云消息-资料不完整
        'messageNewCustome': {component: () => import('@/views/workspace/message/newCustomeTotalDialog')}, //小云消息-新客户汇总
        'reportFollowDetail': {component: () => import('@/views/statement/follow/followDetail')}, //数据中心-跟进情况明细列表
        'departAgentRemove': {component: () => import('@/views/firm/member/departmentAdmin/agentRemove')}, //企业管理-部门人员-删除部门人员(需要转移客户)
          'telPhoneFormRecord': {component: () => import('@/views/apply/telPhoneFormRecord')}, // 租售管理 - 客源管理 - 操作
      },
      currentModal: '',
      prevModal: {},
      cacheList: [],
      isSample: false
    }
  },
  mounted () {
    this.currentModal = this.getType;
  },
  methods: {
    async dealChange () {
      if (!(!!this.currentModal)) {
        if (this.cacheList.length <= 0) {
          this.$parent.dialogChangeCall({category: ''});
          this.$EventBus.$emit(`${this.$route.name}_refresh`, {});
        } else {
          const current = this.cacheList.pop();
          if (current.category === this.prevModal.category) {
            this.isSample = true;
            await this.$nextTick();
            this.$parent.dialogChangeCall({
              ...current,
              isOnlyParams: true
            });
            await this.$nextTick();
            this.currentModal = this.getType;
            this.origin = 'prevBack';
            this.isSample = false;
          } else {
            this.$parent.dialogChangeCall(current);
          }
        }
      } else {
        const next = ['orderDetail', 'bussinessDetail', 'yunVisitorDetail','customerDetail', 'approveBlack', 'approveInvalid', 'approveMerge', 'approveCollision', 'approveLock', 'approveRefund',
        'approveSettlement', 'approveSign', 'approveSubscribe', 'approveRecognition', 'approveLook', 'approveReport', 'approveHelper','clewDetail','dayLogBussinessMember','dayLogBussiness', 'visitorDetail','report',
        'UserCaculate', 'systemHousecardSet', 'systemHousecardDetail', 'messageUserAnalysis', 'messageIncomplete', 'reportFollowDetail', 'messageNewCustome', 'customerFollowDetail'].find(v => v === this.prevModal.category);
        if (next) {
          this.cacheList.push({
            category: this.prevModal.category,
            params: {
              ...this.prevModal.params,
              tabActiveName: this.options.tabActiveName,
              clewTabActive: this.options.clewTabActive
            }
          });
          if (this.options.tabActiveName) {
            delete this.options.tabActiveName;
          }
          if (this.options.clewTabActive) {
            delete this.options.clewTabActive;
          }
        }
      }
      this.prevModal = {
        category: this.currentModal,
        params: {...this.options}
      };
    },
    getApproveName () {
      const {voucher_type} = this.options;
      switch (voucher_type) {
        case 1:
          return 'approveLock';
        case 2:
          return 'approveCollision';
        case 3:
          return 'approveMerge';
        case 4:
          return 'approveInvalid';
        case 5:
          return 'approveBlack';
        case 6:
          return 'approveReport';
        case 7:
          return 'approveLook';
        case 8:
          return 'approveRecognition';
        case 9:
          return 'approveSubscribe';
        case 10:
          return 'approveSign';
        case 11:
          return 'approveSettlement';
        case 12:
          return 'approveRefund';
        case 13:
          return 'approveHelper';
        default:
          return '';
      }
    },
    closeAll () {
      this.prevModal= {};
      this.cacheList= [];
      this.isSample= false;
    }
  }
}
</script>
